var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"diff"},[_c('b',{class:[_vm.percentageColor]},[_c('i',{class:['fa', _vm.percentageArrow]}),_vm._v(" "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),(_vm.showLabel)?[_vm._v("\n        from "+_vm._s(_vm._f("fromNow")(_vm.from))+"\n    ")]:_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0c5564","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PercentChange.vue
// module id = 767
// module chunks = 6